<template>
  <!--.....黑名单的提示.....-->
  <div class="blacklist">
    <el-dialog title="制限リストに登録しますか？" :visible.sync="visible" center :modal="false">
      <div class="">制限リストに登録すると、お互いの投稿へのアクセスや交流が制限されます：
        <p>.相互にフォローが取り消されます</p>
        <p>.お互いのアクティビティーを見ることができなくなります</p>
        <p>.投稿へのレビューやコメント、投げ銭などが相互にできなくなります</p>
        <p>.お互いメッセージの送信をしたり、交流ができなくなります</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">いいえ</el-button>
        <el-button type="primary" @click="addBlackList">はい</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { uploadPost } from '@/assets/js/json'

  export default {
    props: {
      user: {
        type: Object,
        default: null
      },
      uid: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        visible: false
      }
    },
    methods: {
      close () {
        this.visible = false
      },
      open () {
        this.visible = true
      },
      addBlackList () {
        const option = {
          'targetId': this.user.id,
          'type': 'CHAT_BLACK'
        }
        let config = {
          headers: {'Content-Type': 'application/json'}
        }
        uploadPost('/api/member/blacklist/add', option,config).then((res) => {
          const options = {
            'targetId': this.user.id,
            'type': 'MEMBER_BLACK'
          }
          if (res.data.success) {
            uploadPost('/api/member/blacklist/add', options,config).then((ress) => {
              if (res.data.success) {
                if (this.user) {
                  this.user.blacklist = true
                }
                if (this.func) {
                  this.func()
                }
                this.$tips('制限リストに登録しました')
              }
            })
          }
        })
        this.visible = false
      }
    }
  }
</script>

<style lang="less" scoped>
  /*.....隐藏的黑名单......*/


</style>



// WEBPACK FOOTER //
// src/components/tools/addBlackList.vue